import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = `email/contentCalendar/pendingApproval`;

export function useEmailContentCalPendingApprovalQuery(
	params: { enabled?: boolean; impersonationContext?: Api.IImpersonationContext } = {}
) {
	const userSession = useUserSession();
	return useQuery({
		enabled: params.enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<number>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `email/contentCalendar/pendingApproval`,
					impersonationContext: params.impersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY],
		refetchOnWindowFocus: false,
	});
}

export function invalidateEmailContentCalPendingApprovalQuery() {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
}
